import { RefObject } from 'react';

export const CIPrepareDataForm = ({ ciFormRef, prepareData }: { ciFormRef: RefObject<HTMLFormElement | null>; prepareData: Record<string, string> | null }) => {
  return (
    <form ref={ciFormRef} action="https://nice.checkplus.co.kr/CheckPlusSafeModel/service.cb" method="POST" target="_self" style={{ display: 'none' }}>
      {prepareData && Object.entries(prepareData).map(([key, value]) => <input key={key} type="hidden" name={key} value={value} />)}
    </form>
  );
};
